module.exports = __webpack_public_path__ + "img/internal_directory.c05acbe1.png";